import { PAYMENT_BANK_CARD, PAYMENT_GOOGLE_PAY } from 'apps/auth/constants/Constants';
import {
    ACCOUNT_TO,
    FROM_ACCOUNT,
    FROM_PRV_ID,
    PAYMENT_METHOD,
    SOURCE,
    SOURCE_CARD_CVV,
    SOURCE_CARD_EXP_DATE,
    SOURCE_CODE_FROM,
    SOURCE_CODE_TO,
    TO_PRV_ID,
} from 'apps/auth/constants/fieldsName';
import { EXP_DATE } from 'apps/auth/constants/FieldType';

export const getFieldsForLibre = (sourceToLibre, fields) => {
    return {
        ...fields,
        [EXP_DATE]: {
            ...fields[EXP_DATE],
            value: null,
            isError: false,
            mandatory: false,
        },
        [ACCOUNT_TO]: {
            ...fields[ACCOUNT_TO],
            value: null,
            isError: false,
            mandatory: false,
        },
        [TO_PRV_ID]: {
            ...fields[TO_PRV_ID],
            value: sourceToLibre.prvId,
        },
        [SOURCE_CODE_TO]: {
            ...fields[SOURCE_CODE_TO],
            value: sourceToLibre.code,
        },
    };
};

export const getFieldsForGooglePay = (fields, code) => {
    return {
        ...fields,
        [SOURCE]: {
            ...fields[SOURCE],
            value: code,
            isError: false,
        },
        [SOURCE_CODE_FROM]: {
            ...fields[SOURCE_CODE_FROM],
            value: code,
            isError: false,
        },
        [PAYMENT_METHOD]: {
            ...fields[PAYMENT_METHOD],
            value: PAYMENT_GOOGLE_PAY,
            isError: false,
        },
    };
};

export const createPayRequestFields = (fields, item = {}, paymentMethod = PAYMENT_BANK_CARD) => {
    const isCard = paymentMethod === PAYMENT_BANK_CARD;
    const source = item?.code || null;
    const fromPrvId = item?.fromPrvId || null;
    const account = item?.account || null;
    const expDate = item?.cardExpired || null;
    return {
        ...fields,
        [SOURCE]: {
            ...fields[SOURCE],
            value: source,
            isError: false,
        },
        [SOURCE_CODE_FROM]: {
            ...fields[SOURCE_CODE_FROM],
            value: source,
            isError: false,
        },
        [FROM_ACCOUNT]: {
            ...fields[FROM_ACCOUNT],
            value: account,
            isError: false,
            mandatory: isCard,
        },
        [SOURCE_CARD_CVV]: {
            ...fields[SOURCE_CARD_CVV],
            value: null,
            isError: false,
            mandatory: isCard,
        },
        [SOURCE_CARD_EXP_DATE]: {
            ...fields[SOURCE_CARD_EXP_DATE],
            value: expDate,
            isError: false,
            mandatory: isCard,
        },
        [PAYMENT_METHOD]: {
            ...fields[PAYMENT_METHOD],
            value: paymentMethod,
            isError: false,
        },
        [FROM_PRV_ID]: {
            ...fields[FROM_PRV_ID],
            value: fromPrvId,
            mandatory: false,
            isError: false,
        },
    };
};
